import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavItem } from '@app/layouts/parametria-layout/nav.item';
import { MicrosoftAuthService } from '@pages/authentication/services/microsoft-auth.service';

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.css']
})
export class LayoutsComponent implements OnInit {

  navItems: NavItem[];
  jsonModules: any;
  usser: string;
  shouldRun:boolean = true;
  isExpanded = false;
  private expandTimeout: any;

  constructor(
    private router: Router,
    private microsoftAuthService: MicrosoftAuthService
  ) { 
 
  }

  ngOnInit() {
    this.jsonModules = JSON.parse(sessionStorage.getItem('Modules'));
    this.usser = JSON.parse(sessionStorage.getItem('Usser'));
    this.navItems = this.jsonModules;
  }

  goToHome() {
    this.router.navigate(['index']);
  }

  logout() {
    const isMicrosoft = this.microsoftAuthService.logout();
    if (!isMicrosoft) {
      this.router.navigate(['sign-in']);
    }
  }

  isLargeScreen() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 770) {
        return true;
    } else {
        return false;
    }
  }
  
  toggleSidenav(): void {
    this.isExpanded = !this.isExpanded;
    this.router.navigate(['inicio']);
  }

  expandSidenav(): void {
    if (!this.isMobile()) {
      this.isExpanded = true;
    }
  }

  collapseSidenav(): void {
    if (!this.isMobile()) {
      this.isExpanded = false;
    }
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }
}
